module.exports = __webpack_public_path__ + "static/media/sponsorship.96a4e0aa.png";